import React from 'react'
import Logo from '../../Assets/Images/Logo.avif'
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa'

const Footer = () => {
    return (
        <>
            <footer className='border-top'>
                <div className="container py-5">
                    <div className="row justify-content-between py-lg-5">
                        <div className="col-auto">
                            <img src={Logo} width={150} alt="" />

                            <div className='mt-3'>


                                <a className='me-3' href="https://www.facebook.com/popgop.pk" target='_blank'>

                                    <FaFacebookF size={22} />
                                </a>


                                <a href='https://www.youtube.com/@popgopbabydiapers' target='_blank' className='me-3'>

                                    <FaYoutube size={22} />
                                </a>

                                <a href='https://www.instagram.com/popgop.pk/' target='_blank'>
                                    <FaInstagram size={22} />
                                </a>
                            </div>


                        </div>

                        <div className="col-auto">
                            <h5>Let's Talk</h5>
                            <ul>
                                <li>
                                    <a href="tel:03001853666">03001853666</a>
                                </li>
                                <li>
                                    <a href="mailto:popgop.pk@gmail.com">popgop.pk@gmail.com</a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-4">
                            <h5>Find Us </h5>

                            <p>
                                7th Commercial Lane, Zamzama Blvd, DHA Phase 5 Karachi, Pakistan
                            </p>
                        </div>


                        <div className="col-auto">
                            <h5>Contact information</h5>

                            <ul>
                                <li>
                                    <a href="tel:03001853666">03001853666</a>
                                </li>
                                <li>
                                    <a href="mailto:popgop.pk@gmail.com">popgop.pk@gmail.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer